import { type CSSProperties, memo } from 'react';

import { type Board, type PublicBoard } from '@air/api/types';

import { BoardGalleryCard, type BoardGalleryCardProps } from '~/components/Gallery/BoardGalleryCard/BoardGalleryCard';
import { DndSortableKanbanItem } from '~/components/KanbanView/KanbanColumnsManagers/shared/KanbanColumnItems/KanbanItem/shared/DndSortableKanbanItem';
import { KANBAN_BOARD_CARD_HEIGHT, KANBAN_ITEM_CARD_WIDTH } from '~/components/KanbanView/shared/kanbanConstants';
import { type DndSortableKanbanItemData } from '~/types/DndKit';

type KanbanBoardComponentProps<B extends Board | PublicBoard> = {
  dndDisabled?: boolean;
  kanbanDndItemData: DndSortableKanbanItemData;
  style: CSSProperties;
} & Omit<BoardGalleryCardProps<B>, 'cardWidth'>;
const _KanbanBoardComponent = <B extends Board | PublicBoard>({
  dndDisabled,
  kanbanDndItemData,
  style,
  ...rest
}: KanbanBoardComponentProps<B>) => {
  return (
    <DndSortableKanbanItem
      id={kanbanDndItemData.sortableKanbanItemKey}
      data={kanbanDndItemData}
      dndDisabled={dndDisabled}
      style={style}
    >
      <div className="relative" style={{ height: KANBAN_BOARD_CARD_HEIGHT }}>
        <BoardGalleryCard
          cardWidth={KANBAN_ITEM_CARD_WIDTH}
          // biome-ignore lint/performance/noJsxPropsBind: PLA-1724 — pre-existing debt, not introduced by the color pairing
          getButtonClassName={() =>
            'ads:bg-base bg-gray-1 cursor-pointer shadow-md shadow-kanban dark:border ads:border-default dark:border-gray-4'
          }
          {...rest}
        />
      </div>
    </DndSortableKanbanItem>
  );
};

// biome-ignore lint/plugin: memo erases generic params; typeof cast restores inference
export const KanbanBoardComponent = memo(_KanbanBoardComponent) as typeof _KanbanBoardComponent;
